import { CrudList } from '../shared/CrudPage';
import { subscriptionPlanService, enumLabel } from '@kss/api';
import type { SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

export default function AllSubscriptionPlans() {
  return (
    <CrudList<SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter>
      title="Subscription plans" newLabel="New plan" service={subscriptionPlanService}
      idKey="subscriptionPlanId" labelKey="name" basePath="/panel/subscription-plans"
      columns={[
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'tier', title: 'Tier', sortable: true,
          render: (r) => enumLabel('SubscriptionPlanTier', typeof r.tier === 'number' ? r.tier : Number(r.tier)) },
        { accessor: 'monthlyPrice', title: 'Monthly (₹)', sortable: true, textAlign: 'right',
          render: (r) => Number(r.monthlyPrice ?? 0).toLocaleString('en-IN') },
        { accessor: 'yearlyPrice', title: 'Yearly (₹)', sortable: true, textAlign: 'right',
          render: (r) => Number(r.yearlyPrice ?? 0).toLocaleString('en-IN') },
        { accessor: 'maxUsers', title: 'Max users', textAlign: 'right', render: (r) => r.maxUsers ?? '—' },
        { accessor: 'maxStores', title: 'Max stores', textAlign: 'right', render: (r) => r.maxStores ?? '—' },
        { accessor: 'maxProducts', title: 'Max products', textAlign: 'right', render: (r) => r.maxProducts ?? '—' },
        { accessor: 'isActive', title: 'Status', sortable: true,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} /> },
      ]}
    />
  );
}
